import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './upcoming-events-styles.css';
import {BASE_URL, Endpoints} from '../../constants/urls'
import { Carroussel } from '../carousel/carousel';
export const UpcomingEvents = () => {


  const [upcomingEvents, setUpcomingEvents] = useState([]);

  useEffect(() => {
    axios
    .get(`${BASE_URL}${Endpoints.GetUpcomingEvents}`)
    .then((response) => {
      setUpcomingEvents(response?.data);
    })
    .catch((error) => {
      console.error('There was an error making the GET request!', error);
    });
  }, []);

  return (
    <>
      <div style={{paddingBottom:"3.5rem"}}>
      <div className='event-container'>
        <h2  className='expect-heading bar' style={{marginBottom:"1rem"}}>
          Upcoming  <span className='text-theme head-font'>Events</span>
        </h2>

        {
          upcomingEvents.length > 0 ?
        
        <Carroussel
          upcomingEvents={upcomingEvents}
          width='100%'
          margin='0 auto'
          offset={200}
          showArrows={false}
        />
        : <div>
         <img width={100} src={require('../../assets/No-Data.png')}/>
         <h6 className='mt-3 text-theme'>Next Event Coming Soon         </h6>
         <p>No events scheduled right now. Keep visiting to catch the next one!
         </p>
       </div>
      }
      </div>
      </div>
    </>
  );
};
